import { InputRow, ModelNewNumericInput, SVGInfo } from '@equifinance/shared';

export function SA302Evidence({
  field,
}: {
  field: string,
}) {
  const fieldPath = `${field}.sA302Evidence`;

  return (
    <>
      <SVGInfo>
        3 months bank statements will be required.
      </SVGInfo>
      <InputRow>
        <ModelNewNumericInput
          label="Total gross annual income"
          prefix="£"
          field={`${fieldPath}.grossAnnualIncome`}
          maxCharacters={10}
          isFixedDecimal
          required
        />
        <ModelNewNumericInput
          label="Deductions"
          prefix="£"
          field={`${fieldPath}.deductions`}
          maxCharacters={10}
          isFixedDecimal
          required
        />
        <ModelNewNumericInput
          label="Net monthly income"
          prefix="£"
          field={`${fieldPath}.netMonthlyIncome`}
          isFixedDecimal
          required
          disabled
        />
      </InputRow>
    </>
  );
}
